import {
  archiveMilestoneTemplate,
  createMilestoneTemplate,
  fetchAllMilestoneTemplates,
  fetchMilestoneTemplateById,
  updateMilestoneTemplate,
} from '../../routines/successplanTemplates/milestoneTemplates';

const initialState = {
  selectedMilestoneTemplate: null,
  selectedMilestoneTemplateLoading: false,
  selectedMilestoneTemplateSuccess: true,
  milestoneTemplateList: [],
  milestoneTemplateListLoading: false,
  milestoneTemplateListSuccess: false,
  milestoneTemplateCreating: false,
  milestoneTemplateCrateSuccess: false,
  milestoneTemplateUpdating: false,
  milestoneTemplateUpdateSuccess: false,
  milestoneTemplateArchiving: false,
  milestoneTemplateArchiveSuccess: false,
};

const successPlanTemplatemilestoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchAllMilestoneTemplates.TRIGGER:
      return {
        ...state,
        milestoneTemplateCrateSuccess: false,
        milestoneTemplateListLoading: true,
      };
    case fetchAllMilestoneTemplates.SUCCESS:
      return {
        ...state,
        milestoneTemplateCrateSuccess: true,
        milestoneTemplateListLoading: false,
        milestoneTemplateList: action.payload?.data || [],
      };
    case fetchAllMilestoneTemplates.FAILURE:
      return {
        ...state,
        milestoneTemplateCrateSuccess: false,
        milestoneTemplateListLoading: false,
      };

    case fetchMilestoneTemplateById.TRIGGER:
      return {
        ...state,
        selectedMilestoneTemplateSuccess: false,
        selectedMilestoneTemplateLoading: true,
        selectedMilestoneTemplate: null,
      };
    case fetchMilestoneTemplateById.SUCCESS:
      return {
        ...state,
        selectedMilestoneTemplateSuccess: true,
        selectedMilestoneTemplateLoading: false,
        selectedMilestoneTemplate: action.payload?.data || null,
      };
    case fetchMilestoneTemplateById.FAILURE:
      return {
        ...state,
        selectedMilestoneTemplateSuccess: false,
        selectedMilestoneTemplateLoading: false,
        selectedMilestoneTemplate: null,
      };

    case createMilestoneTemplate.TRIGGER:
      return {
        ...state,
        milestoneTemplateCreating: true,
        milestoneTemplateCrateSuccess: false,
      };
    case createMilestoneTemplate.SUCCESS:
      return {
        ...state,
        milestoneTemplateCreating: false,
        milestoneTemplateCrateSuccess: true,
      };
    case createMilestoneTemplate.FAILURE:
      return {
        ...state,
        milestoneTemplateCreating: false,
        milestoneTemplateCrateSuccess: false,
      };

    case updateMilestoneTemplate.TRIGGER:
      return {
        ...state,
        milestoneTemplateUpdating: true,
        milestoneTemplateUpdateSuccess: false,
      };
    case updateMilestoneTemplate.SUCCESS:
      return {
        ...state,
        milestoneTemplateUpdating: false,
        milestoneTemplateUpdateSuccess: true,
      };
    case updateMilestoneTemplate.FAILURE:
      return {
        ...state,
        milestoneTemplateUpdating: false,
        milestoneTemplateUpdateSuccess: false,
      };

    case archiveMilestoneTemplate.TRIGGER:
      return {
        ...state,
        milestoneTemplateArchiving: true,
        milestoneTemplateArchiveSuccess: false,
      };
    case archiveMilestoneTemplate.SUCCESS:
      return {
        ...state,
        milestoneTemplateArchiving: false,
        milestoneTemplateArchiveSuccess: true,
      };
    case archiveMilestoneTemplate.FAILURE:
      return {
        ...state,
        milestoneTemplateArchiving: false,
        milestoneTemplateArchiveSuccess: false,
      };
    default:
      return state;
  }
};

export default successPlanTemplatemilestoneReducer;
